import { useCallback, useEffect, useState } from 'react';

// Per-browser map display prefs: label category toggles.

const STORAGE_KEY = 'ss.mapPrefs.v1';

export interface LabelPrefs { streets: boolean; landmarks: boolean; state: boolean }
interface Stored { labels: LabelPrefs }

const DEFAULTS: Stored = { labels: { streets: true, landmarks: true, state: true } };

function load(): Stored {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const p = JSON.parse(raw);
      return { labels: { ...DEFAULTS.labels, ...p.labels } };
    }
  } catch { /* storage unavailable or corrupt */ }
  return DEFAULTS;
}

export function useMapPrefs() {
  const [state, setState] = useState<Stored>(load);

  useEffect(() => {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch { /* ignore */ }
  }, [state]);

  const setLabel = useCallback((k: keyof LabelPrefs, v: boolean) =>
    setState(s => ({ ...s, labels: { ...s.labels, [k]: v } })), []);
  const resetAll = useCallback(() => setState(DEFAULTS), []);

  return { labels: state.labels, setLabel, resetAll };
}
